import { getCurrentUserId } from '@tabeeb/modules/account/selectors'
import {
  checkConditionsRequest,
  getAiCounterInfoByFormRecordRequest,
  getAiCounterInfoRequest,
  getAiObjectsCountRequest,
} from '@tabeeb/modules/artificialIntelligence/actions'
import { deleteGalleryItemSuccess, onDeleteGalleryItem } from '@tabeeb/modules/gallery/actions'
import { getContentId } from '@tabeeb/modules/shared/content/selectors'
import { put, takeLatest, select, all } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import { getContentForm, getCounterInfo } from '../actions'
import { getContentForms, getCurrentForm } from '../selectors'

function* onGetCounterInfo(): SagaIterator {
  const contentId: ReturnType<typeof getContentId> = yield select(getContentId)
  const currentForm: ReturnType<typeof getCurrentForm> = yield select(getCurrentForm)

  if (!currentForm) {
    return
  }

  const selectedRecord = currentForm.selectedRecord || 0
  const hasCounters = currentForm.Counters && currentForm.Counters.length > 0

  if (hasCounters) {
    let data: {
      contentId: number
      formRecordId?: number
    } = { contentId }

    if (selectedRecord) {
      data = { ...data, formRecordId: selectedRecord }

      yield put(getAiCounterInfoByFormRecordRequest(data))
    }

    yield put(getAiCounterInfoRequest(data))
  }
}

function* getAIObjectsCount(): SagaIterator {
  const contentId: ReturnType<typeof getContentId> = yield select(getContentId)
  const contentForms: ReturnType<typeof getContentForms> = yield select(getContentForms)

  const hasCounters = contentForms.some((cf) => cf.HasCounters)
  if (hasCounters) {
    yield put(getAiObjectsCountRequest({ contentId }))
  }
}

function* checkCounterConditions(action: ReturnType<typeof getContentForm.success>): SagaIterator {
  const form = action.response.data
  const contentId: ReturnType<typeof getContentId> = yield select(getContentId)
  const currentUserId: ReturnType<typeof getCurrentUserId> = yield select(getCurrentUserId)
  const userId = action.payload.UserId

  if (form.HasCountersWithConditions && currentUserId === userId) {
    yield put(checkConditionsRequest({ contentId }))
  }
}

function* counterInfo() {
  yield all([
    takeLatest(getCounterInfo, onGetCounterInfo),
    takeLatest([deleteGalleryItemSuccess, onDeleteGalleryItem], getAIObjectsCount),
    takeLatest(getContentForm.success, checkCounterConditions),
  ])
}

export default counterInfo
